module.exports = __webpack_public_path__ + "static/magma_mephit-69182fdf95d93c20c216f13d6cb7f924.jpeg";